import { render, staticRenderFns } from "./OMSRules.vue?vue&type=template&id=07c6a1a0"
import script from "./OMSRules.vue?vue&type=script&lang=js"
export * from "./OMSRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports